import PrivacyPolicy from '@/assets/betgalaxy/pdf/privacy_policy.pdf';
import TermsAndConditions from '@/assets/betgalaxy/pdf/terms_and_conditions.pdf';

export default {
  PrivacyPolicy,
  TermsAndConditions,
};
